import axios from 'axios';
import { call } from 'redux-saga/effects';
import {
    GET_FESTIVAL_DETAILS_ENDPOINT,
    GET_FESTIVALS_ENDPOINT,
    ADD_FESTIVAL_TO_FAVORITE_ENDPOINT,
    REMOVE_FESTIVAL_FROM_FAVORITE_ENDPOINT,
    GET_FESTIVAL_LOCATIONS_ENDPOINT,
    GET_EVENTS_ENDPOINT,
    ADD_EVENT_TO_FAVORITE_ENDPOINT,
    REMOVE_EVENT_FROM_FAVORITE_ENDPOINT,
    GET_EVENT_DETAILS_ENDPOINT
} from '../config/apiEndpoints';
import { getTokenHeaders as tokenHeader } from '../helpers/api.helper';

export function* getFestivalDetails(payload){
    const header = tokenHeader();
    return yield call(axios.get, GET_FESTIVAL_DETAILS_ENDPOINT + payload, header);
}

export function* getFestivals(payload){
    const header = tokenHeader();
    const url = GET_FESTIVALS_ENDPOINT + payload
    return yield call(axios.get, url, header);
}

export function* addFestivalToFavorite(payload){
    const header = tokenHeader();
    const body = {
        "data": {
          "type": "favourite_festival--favourite_festival",
          "relationships": {
              "festival": {
                  "data": {
                      "type": "festival--festival",
                      "id": payload
                  }
              }
          }
        }
    }
    return yield call(axios.post, ADD_FESTIVAL_TO_FAVORITE_ENDPOINT, body, header);
}

export function* removeFestivalFromFavorite(payload){
    const header = tokenHeader();
    return yield call(axios.delete, REMOVE_FESTIVAL_FROM_FAVORITE_ENDPOINT + payload, header);
}

export function* getFestivalLocations(payload){
    const header = tokenHeader();
    return yield call(axios.get, GET_FESTIVAL_LOCATIONS_ENDPOINT + payload, header);
}

export function* getEvents(payload){
    const header = tokenHeader();
    let url = "";
    payload.location ? 
     url = GET_EVENTS_ENDPOINT + payload.festival_id + "/" + payload.date + "?_format=api_json&event_location=" + payload.location  :
     url = GET_EVENTS_ENDPOINT + payload.festival_id + "/" + payload.date + "?_format=api_json";

    return yield call(axios.get, url, header);
}

export function* addEventToFavorite(payload){
    const header = tokenHeader();
    const body = {
        "data": {
            "type": "favourite_event--favourite_event",
            "relationships": {
                "event": {
                    "data": {
                        "type": "event--event",
                        "id": payload
                    }
                }
            }
        }
    }
    return yield call(axios.post, ADD_EVENT_TO_FAVORITE_ENDPOINT, body, header);
}

export function* removeEventFromFavorite(payload){
    const header = tokenHeader();
    return yield call(axios.delete, REMOVE_EVENT_FROM_FAVORITE_ENDPOINT + payload, header);
}

export function* getEventsDetails(payload){
    const header = tokenHeader();
    return yield call(axios.get, GET_EVENT_DETAILS_ENDPOINT + payload, header);
}


// WEBPACK FOOTER //
// ./src/SHARED/api/festival.api.js